import { useQuery } from "@tanstack/react-query";
import type { EmissionRecordsEmissionRecordStatsRetrieveRequest } from "../../apiClient/generated";
import { useEmissionRecordsApiClient } from "../../hooks";
import {
    DashboardMetric,
    DashboardStatsGroup,
} from "../../ui/DashboardComponents";

interface StatsPanelProps {
    title: string;
    filters: EmissionRecordsEmissionRecordStatsRetrieveRequest;
}

export const EmissionDashboardStatsPanel = (props: StatsPanelProps) => {
    const emissionApiClient = useEmissionRecordsApiClient();

    const emissionsQuery = useQuery({
        queryKey: ["emissionRecordStats", props.filters],
        queryFn: async () => {
            return await emissionApiClient.emissionRecordsEmissionRecordStatsRetrieve(
                {
                    ...props.filters,
                    isMainEvent: true,
                },
            );
        },
        keepPreviousData: true,
        refetchOnWindowFocus: false,
        staleTime: 3600 * 1000,
    });

    return (
        <div className="p-6 flex justify-between max-w-full gap-2 overflow-x-scroll">
            <DashboardStatsGroup title="Emission Counts">
                <DashboardMetric
                    value={emissionsQuery.data?.lastNDays}
                    label="Added last 90 days"
                />
                <DashboardMetric
                    value={emissionsQuery.data?.total}
                    label="Total Events"
                />
            </DashboardStatsGroup>
            <DashboardStatsGroup title="Emission Rates">
                <DashboardMetric
                    value={`${(emissionsQuery.data?.highestRate / 1000).toFixed(
                        0,
                    )} kg/h`}
                    label={"Highest event"}
                />
                <DashboardMetric
                    value={`${(emissionsQuery.data?.avgRate / 1000).toFixed(
                        0,
                    )} kg/h`}
                    label={"Average"}
                />
            </DashboardStatsGroup>
            <DashboardStatsGroup title="Event Status">
                <DashboardMetric
                    value={emissionsQuery.data?._new}
                    label={"New"}
                />
                <DashboardMetric
                    value={emissionsQuery.data?.inProgress}
                    label={"In progress"}
                />
                <DashboardMetric
                    value={emissionsQuery.data?.complete}
                    label={"Completed"}
                />
            </DashboardStatsGroup>
        </div>
    );
};
